import React from "react";
import { Toggle } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Toggle dark mode for convention form.
 */
export const ToggleDarkMode = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-dark-mode-error",
  };

  const inputProps = {
    id: "toggle-dark-mode",
    className: "form-control",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "switch form-control-label",
    htmlFor: inputProps.id,
    children: "DARK MODE",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.DARK_MODE,
  };

  return <Toggle {...parentProps} />;
};
